import React, { Component } from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const AuthContext = React.createContext()

class AuthProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loggedIn: true,
      user: { id: '' },
      notifications: {
        messages: 0,
      },
    }
    this.handleLoginCheck = this.handleLoginCheck.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.handleEditorLogin = this.handleEditorLogin.bind(this)
    this.handleEditorLogout = this.handleEditorLogout.bind(this)
    this.isEditor = this.isEditor.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.getNotifications = this.getNotifications.bind(this)
    this.refreshUser = this.refreshUser.bind(this)
    this.handleLoginCheck()
  }

  // Updates the current state and the DB
  updateUser(values) {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        {
          user: Object.assign(prevState.user, values)
        }
        // {user: ...prevState.user, values};
      })
      // ud stands for user data
      var currentStorageUser = JSON.parse(localStorage.getItem('ud'))
      currentStorageUser = Object.assign(currentStorageUser, values)
      localStorage.setItem('ud', JSON.stringify(currentStorageUser))

      const headers = {
        'Content-Type': 'application/json',
      }

      axios
        .post('/api/user', { user: values }, headers)
        .then((response) => {
          resolve(response)
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            window.open('/auth0/logout', '_self')
          }
          reject(error)
        })
    })
  }

  getNotifications() {
    if (this.state.user.id !== '') {
      axios
        .get('/api/user/notifications')
        .then((response) => {
          this.setState({ notifications: response.data })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  handleLogin(user) {
    this.setState({
      loggedIn: true,
      user: user !== null ? user : { id: '' },
    })
    if (user !== null) {
      // ud stands for user data
      localStorage.setItem('ud', JSON.stringify(user))
    }
  }

  handleEditorLogin(user) {
    this.setState({ loggedIn: true, user: user, editor: true })
  }

  refreshUser() {
    this.handleLoginCheck()
  }

  handleLoginCheck() {
    axios
      .get('/api/loggedIn')
      .then((response) => {
        this.setState(response.data)
        // ud stands for user data
        localStorage.setItem('ud', JSON.stringify(response.data.user))
        this.getNotifications()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  isEditor() {
    axios
      .get('/api/editor/loggedIn')
      .then((response) => {
        return response.data.loggedIn
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleLogout() {
    axios
      .post('/api/logout')
      .then((response) => {
        this.setState({ loggedIn: false })
        this.setState({ user: { id: '' } })
        // ud stands for user data
        localStorage.removeItem('ud')
        cookies.remove('laravelsession')
        this.props.history.push('/')
      })
      .catch((err) => {
        this.props.history.push('/')
      })
  }

  handleEditorLogout() {
    axios
      .post('/api/editor/logout')
      .then((response) => {
        this.setState({ loggedIn: false, editor: false })
        this.props.history.push('/admin/login')
      })
      .catch((err) => {
        this.props.history.push('/admin/login')
      })
  }

  render() {
    return (
      <AuthContext.Provider
        value={{
          loggedIn: this.state.loggedIn,
          user: this.state.user,
          notifications: this.state.notifications,
          editor: this.state.editor,
          handleLogout: this.handleLogout,
          handleLoginCheck: this.handleLoginCheck,
          handleLogin: this.handleLogin,
          handleEditorLogin: this.handleEditorLogin,
          handleEditorLogout: this.handleEditorLogout,
          isEditor: this.isEditor,
          updateUser: this.updateUser,
          getNotifications: this.getNotifications,
          refreshUser: this.refreshUser,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    )
  }
}

const AuthConsumer = AuthContext.Consumer
// use the withRouter HOC which adds the history prop
AuthProvider = withRouter(AuthProvider)

export { AuthProvider, AuthConsumer }

// Provide access to AuthContext via HOC
// This function takes a component...
export function withAuth(WrappedComponent) {
  // ...and returns another component...
  return function AuthComponent(props) {
    // ... and renders the wrapped component with the auth context
    // Notice that we pass through any additional props as well
    return (
      <AuthContext.Consumer>
        {(auth) => <WrappedComponent {...props} auth={auth} />}
      </AuthContext.Consumer>
    )
  }
}

// Create an authenticated route
// checks if the user is authenticated, if they are,
// it renders the "component" prop. If not, it redirects
// the user to /loginsignup.
export function PrivateRoute({ component: Component, ...rest }) {
  return (
    <AuthContext.Consumer>
      {({ loggedIn }) => (
        <Route
          {...rest}
          render={(props) =>
            loggedIn === true ? (
              <Component {...props} />
            ) : (
              window.open('/auth0/logout', '_self')
              /*
              <Redirect
                to={{
                  pathname: '/loggedout',
                  state: { from: props.location },
                }}
              />
              */
            )
          }
        />
      )}
    </AuthContext.Consumer>
  )
}

// Create an authenticated route
// checks if the user is authenticated, if they are,
// it renders the "component" prop. If not, it redirects
// the user to /loginsignup.
export function PrivateAdminRoute({ component: Component, ...rest }) {
  return (
    <AuthContext.Consumer>
      {({ loggedIn, user, editor }) => (
        <Route
          {...rest}
          render={(props) =>
            loggedIn === true && editor === true && user.role === 'editor' ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: '/admin/login',
                  state: { from: props.location },
                }}
              />
            )
          }
        />
      )}
    </AuthContext.Consumer>
  )
}
